// extracted by mini-css-extract-plugin
export default {"terminal":"Terminal_terminal__-lzHO","output":"Terminal_output__NdE+d"};